// extracted by mini-css-extract-plugin
module.exports = {"btn":"CustomButton_btn__XEOlw","touch-hover":"CustomButton_touch-hover__1nV8O","link":"CustomButton_link__1QIbN","light":"CustomButton_light__MFK-E"};